export default __webpack_public_path__ + "static/media/default-user.a62fc19c.png";